export const TRANSFER_SIDES = {
  SPOT_TO_MARGIN: 2,
  MARGIN_TO_SPOT: 1,
};
